import { render, staticRenderFns } from "./EditTeamMemberDialog.vue?vue&type=template&id=49c0f534&"
import script from "./EditTeamMemberDialog.vue?vue&type=script&lang=js&"
export * from "./EditTeamMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports